/** Global react-tooltip v5 instance in {@link ../ui/Layout.jsx} */
export const TOOLTIP_MAIN = 'tooltip-main'

/** Preferences overlay — see {@link ../ui/PreferencesCalendar.jsx} */
export const TOOLTIP_PREFS = 'tooltip-prefs'
